import { CommonFunctions } from '../static/common-functions';
import { Subscription } from 'rxjs';
import { BasePage } from './BasePage';
import { StatusHistoryBus } from './StatusHistoryBus';
//import { CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY } from '@angular/cdk/overlay/typings/overlay-directives';
import { CustomerService } from '../services/customer.service';
import { CustomerContactBus } from './CustomerContactBus';
import { CustomerPricingBus } from './CustomerPricingBus';
import { BillingCodeRatesBus } from './BillingCodeRatesBus';
import { CustomerProceduresBus } from './CustomerProceduresBus';
import { CustomerInventoryBus } from './CustomerInventoryBus';
import { GItem } from './GItem';
import { CustomerInvoiceChecklistBus } from './CustomerInvoiceChecklistBus';
import { CustomerCustomerForms } from './CustomerCustomerForms';
import { CustomerOnbDataBus } from './CustomerOnbDataBus';
import { CustomerPmsBus } from './CustomerPmsBus';
import { CustomerDispatchStatistics } from './CustomerDispatchStatistics';
import { CustomerDispatchStatisticsDetail } from './CustomerDispatchStatisticsDetail';
import { SubCategoryMarkUpBus } from './SubCategoryMarkUpBus';
import { InventoryReference } from './InventoryReference';
import { GlobalsService } from '../services/globals.service';
import { CustomerInvoiceBillingCodeBus } from './CustomerInvoiceBillingCodeBus';
import { CustomerInvoiceBillingCodeMarkupBus } from './CustomerInvoiceBillingCodeMarkupBus';
import { DQOIReferenceData } from './DQOIReferenceData';
import { v_InvoiceCheckListAttachmentBus } from './v_InvoiceCheckListAttachmentBus';
import { v_InvoiceCheckListNoteBus } from './v_InvoiceCheckListNoteBus';

export class CustomerPage extends BasePage<CustomerService>
{

    svc_data: CustomerService;
    constructor(svc_data: CustomerService, private globals: GlobalsService, data: CustomerPage = null) {
        super();

        this.svc_data = svc_data;
        if (data !== null) {
            //      this.dispatchId = data.dispatchId;
        }
    }

    clear() {
        this.unsubscribe();
        this.id = null;
        this.statusHistory = null;
    }
    unsubscribe() {
        CommonFunctions.unsubscribe(this.subs_statusHistory);
    }

    subs_statusHistory: Subscription;
    subs_contacts: Subscription;
    subs_pricing: Subscription;
    subs_billingCodeRate: Subscription;
    subs_procedure: Subscription;
    subs_location: Subscription;
    subs_checkList: Subscription;
    subs_dispatchStats: Subscription;
    subs_markUp: Subscription;
    subs_billingCodeMarkUp: Subscription;
    subs_pricinghistory: Subscription;
    subs_markUpHistory: Subscription;
    subs_billingCodeMarkUpHistory: Subscription;
    subs_invoiceBillingCodes: Subscription;
    subs_inventory: Subscription;
    subs_customerUsers: Subscription;
    subs_customerPM: Subscription;
    subs_customerCustomForms: Subscription;
    subs_onbData: Subscription;
    getStatusHistory(id: any) {
        //CommonFunctions.unsubscribe(this.subs_statusHistory);
        //this.subs_statusHistory = this.svc_data.getStatusHistory(id).subscribe(data => {
        //    this.statusHistory = data;
        //});
    }
    id: any;
    statusHistory: StatusHistoryBus[];
    get hasStatusHistory(): boolean {
        return CommonFunctions.hasValue(this.statusHistory);
    }

    customerContact: CustomerContactBus[];
    customerContactsLoading = false;
    getCustomerContacts(id: any) {
        CommonFunctions.unsubscribe(this.subs_contacts);
        this.customerContactsLoading = true;
        this.subs_contacts = this.svc_data.getCustomerContacts(id).subscribe(
            {
                next:
                    data => {
                        let arr = [];
                        if (CommonFunctions.hasArrayValue(data)) {
                            for (let i = 0; i < data.length; i++) {
                                let newObj: CustomerContactBus = new CustomerContactBus(data[i]);
                                arr.push(newObj);
                            }
                        }
                        this.customerContact = arr;
                        this.customerContactsLoading = false;
                    },
                error: (err) => {
                    console.error(err);
                    this.customerContactsLoading = false;
                }
            });
    }

    get hasCustomerContact(): boolean {
        return CommonFunctions.hasValue(this.customerContact);
    }
    get hasCustomerPricing(): boolean {
        return CommonFunctions.hasValue(this.customerPricing);
    }
    customerPricing: CustomerPricingBus[];
    getCustomerPricing(id: any, isAdded: boolean) {
        if (!isAdded) {
            CommonFunctions.unsubscribe(this.subs_pricing);
            this.subs_pricing = this.svc_data.getCustomerPricing(id).subscribe(data => {
                let arr = [];
                if (CommonFunctions.hasArrayValue(data)) {
                    for (let i = 0; i < data.length; i++) {
                        let newObj: CustomerPricingBus = new CustomerPricingBus(data[i]);
                        arr.push(newObj);
                    }
                }
                this.customerPricing = arr;
            });
            this.getCustomerPricingHistory(id);
        }
        else {
            CommonFunctions.unsubscribe(this.subs_pricing);
            this.subs_pricing = this.svc_data.getCompanyPricing(this.globals.companyId).subscribe(data => {
                let arr = [];
                if (CommonFunctions.hasArrayValue(data)) {
                    for (let i = 0; i < data.length; i++) {
                        let newObj: CustomerPricingBus = new CustomerPricingBus(null);
                        newObj.customerPricingId = data[i].companyPricingId;
                        newObj.low = data[i].low;
                        newObj.high = data[i].high;
                        newObj.markup = data[i].markup;
                        newObj.isAdded = true;
                        newObj.insertDt = new Date(Date.now());
                        newObj.updateDt = new Date(Date.now());
                        newObj.insertUserId = this.globals.userId;
                        newObj.updateUserId = this.globals.userId;
                        arr.push(newObj);
                    }
                }
                this.customerPricing = arr;
            });
        }
    }
    customerPricingHistory: CustomerPricingBus[];
    getCustomerPricingHistory(id: any) {
        if (!id) return;

        CommonFunctions.unsubscribe(this.subs_pricinghistory);
        this.subs_pricinghistory = this.svc_data.getCustomerPricingHistory(id).subscribe(data => {
            let arr = [];
            if (CommonFunctions.hasArrayValue(data)) {
                for (let i = 0; i < data.length; i++) {
                    let newObj: CustomerPricingBus = new CustomerPricingBus(data[i]);
                    arr.push(newObj);
                }
            }
            this.customerPricingHistory = arr;
        });
    }
    get hasSubCategoryMarkUp(): boolean {
        return CommonFunctions.hasValue(this.subCategoryMarkUp);
    }
    subCategoryMarkUp: SubCategoryMarkUpBus[];
    getSubCategoryMarkUp(id: any, inventoryReference: InventoryReference) {
        CommonFunctions.unsubscribe(this.subs_markUp);
        this.subs_markUp = this.svc_data.getGubCategoryMarkUp(id).subscribe(data => {
            let arr = [];
            if (CommonFunctions.hasArrayValue(data)) {
                for (let i = 0; i < data.length; i++) {
                    let newObj: SubCategoryMarkUpBus = new SubCategoryMarkUpBus(data[i]);
                    newObj.inventorySubCategory = inventoryReference.getInventorySubCategories(newObj.inventorySubCategoryId);
                    newObj.subCategoryPricetype = inventoryReference.getSubCategoryPriceTypes(newObj.subCategoryPricetypeId);
                    arr.push(newObj);
                }
            }
            this.subCategoryMarkUp = arr;
        });

        this.getSubCategoryMarkUpHistory(id, inventoryReference);
    }
    subCategoryMarkUpHistory: SubCategoryMarkUpBus[];
    getSubCategoryMarkUpHistory(id: any, inventoryReference: InventoryReference) {
        CommonFunctions.unsubscribe(this.subs_markUpHistory);
        this.subs_markUpHistory = this.svc_data.getGubCategoryMarkUpHistory(id).subscribe(data => {
            let arr = [];
            if (CommonFunctions.hasArrayValue(data)) {
                for (let i = 0; i < data.length; i++) {
                    let newObj: SubCategoryMarkUpBus = new SubCategoryMarkUpBus(data[i]);
                    newObj.inventorySubCategory = inventoryReference.getInventorySubCategories(newObj.inventorySubCategoryId);
                    newObj.subCategoryPricetype = inventoryReference.getSubCategoryPriceTypes(newObj.subCategoryPricetypeId);
                    newObj.createdUser = inventoryReference.getUser(data[i].updateUserId);
                    arr.push(newObj);
                }
            }
            this.subCategoryMarkUpHistory = arr;
        });
    }

    get hasBillingCodeRates(): boolean {
        return CommonFunctions.hasValue(this.billingCodeRates);
    }
    billingCodeRates: BillingCodeRatesBus[];
    getBillingCodeRates(id: any, referenceData: DQOIReferenceData) {
        CommonFunctions.unsubscribe(this.subs_billingCodeRate);
        this.subs_billingCodeRate = this.svc_data.getBillingCodeRates(id).subscribe(data => {
            let arr = [];
            if (CommonFunctions.hasArrayValue(data)) {
                for (let i = 0; i < data.length; i++) {
                    let newObj: BillingCodeRatesBus = new BillingCodeRatesBus(data[i]);
                    newObj.billingCode = referenceData.getBillingCodeDesc(newObj.billingCodeId);
                    arr.push(newObj);
                }
            }
            this.billingCodeRates = arr;
        });
        this.getBillingCodeRatesHistory(id);
    }
    billingCodeRatesHistory: BillingCodeRatesBus[];
    getBillingCodeRatesHistory(id: any) {
        CommonFunctions.unsubscribe(this.subs_billingCodeMarkUpHistory);
        this.subs_billingCodeMarkUpHistory = this.svc_data.getBillingCodeRatesHistory(id).subscribe(data => {
            let arr = [];
            if (CommonFunctions.hasArrayValue(data)) {
                for (let i = 0; i < data.length; i++) {
                    let newObj: BillingCodeRatesBus = new BillingCodeRatesBus(data[i]);
                    arr.push(newObj);
                }
            }
            this.billingCodeRatesHistory = arr;
        });
    }
    get hasCustomerInvoiceBillingCodes(): boolean {
        return CommonFunctions.hasValue(this.customerInvoiceBillingCodes);
    }
    customerInvoiceBillingCodes: CustomerInvoiceBillingCodeBus[];
    getCustomerInvoiceBillingCodes(id: any) {
        if (!id) {
            this.customerInvoiceBillingCodes = [];
            console.error('Customer ID is null or undefined. Cannot fetch billing codes.');
            return;
        }
        CommonFunctions.unsubscribe(this.subs_invoiceBillingCodes);
        this.subs_invoiceBillingCodes = this.svc_data.getCustomerInvoiceBillingCodes(id).subscribe(data => {
            let arr = [];
            if (CommonFunctions.hasArrayValue(data)) {
                for (let i = 0; i < data.length; i++) {
                    let newObj: CustomerInvoiceBillingCodeBus = new CustomerInvoiceBillingCodeBus(data[i]);
                    arr.push(newObj);
                }
            }
            this.customerInvoiceBillingCodes = arr;
        });
    }

    get hasCustomerInvoiceBillingCodeMarkups(): boolean {
        return CommonFunctions.hasValue(this.customerInvoiceBillingCodeMarkups);
    }
    customerInvoiceBillingCodeMarkups: CustomerInvoiceBillingCodeMarkupBus[];
    getCustomerInvoiceBillingCodesMarkups(id: any) {
        CommonFunctions.unsubscribe(this.subs_billingCodeMarkUp);
        this.subs_billingCodeMarkUp = this.svc_data.getCustomerInvoiceBillingCodeMarkups(id).subscribe(data => {
            let arr = [];
            if (CommonFunctions.hasArrayValue(data)) {
                for (let i = 0; i < data.length; i++) {
                    let newObj: CustomerInvoiceBillingCodeMarkupBus = new CustomerInvoiceBillingCodeMarkupBus(data[i]);
                    arr.push(newObj);
                }
            }
            this.customerInvoiceBillingCodeMarkups = arr;
        });
    }

    get hasProcedures(): boolean {
        return CommonFunctions.hasValue(this.customerProcedures);
    }
    customerProcedures: CustomerProceduresBus[];
    getCustomerProcedures(id: any) {
        CommonFunctions.unsubscribe(this.subs_procedure);
        this.subs_procedure = this.svc_data.getCustomerProcedures(id).subscribe(data => {
            let arr = [];
            if (CommonFunctions.hasArrayValue(data)) {
                for (let i = 0; i < data.length; i++) {
                    let newObj: CustomerProceduresBus = new CustomerProceduresBus(data[i]);
                    arr.push(newObj);
                }
            }
            this.customerProcedures = arr;
        });
    }
    get hasInventory(): boolean {
        return CommonFunctions.hasValue(this.customerInventory);
    }
    customerInventory: CustomerInventoryBus[];
    getCustomerInventory(id: any) {
        CommonFunctions.unsubscribe(this.subs_inventory);
        this.subs_inventory = this.svc_data.getCustomerInventory(id).subscribe(data => {
            let arr = [];
            if (CommonFunctions.hasArrayValue(data)) {
                for (let i = 0; i < data.length; i++) {
                    let newObj: CustomerInventoryBus = new CustomerInventoryBus(data[i]);
                    arr.push(newObj);
                }
            }
            this.customerInventory = arr.sort((a, b) => (a.number > b.number) ? 1 : -1);
        });
        this.getCustomerInventoryHistory(id);
    }
    customerInventoryHistory: CustomerInventoryBus[];
    getCustomerInventoryHistory(id: any) {
        CommonFunctions.unsubscribe(this.subs_pricinghistory);
        this.subs_pricinghistory = this.svc_data.getCustomerInventoryHistory(id).subscribe(data => {
            let arr = [];
            if (CommonFunctions.hasArrayValue(data)) {
                for (let i = 0; i < data.length; i++) {
                    let newObj: CustomerInventoryBus = new CustomerInventoryBus(data[i]);
                    arr.push(newObj);
                }
            }
            this.customerInventoryHistory = arr.sort((a, b) => (a.number > b.number) ? 1 : -1);
        });
    }
    get hasCheckList(): boolean {
        return CommonFunctions.hasValue(this.checkList);
    }
    checkList: CustomerInvoiceChecklistBus[];
    getCheckList(id: any) {
        CommonFunctions.unsubscribe(this.subs_contacts);
        this.subs_checkList = this.svc_data.getCustomerInvoiceChecklists(id).subscribe(data => {

            let arr = [];
            if (CommonFunctions.hasArrayValue(data)) {
                for (let i = 0; i < data.length; i++) {
                    let newObj: CustomerInvoiceChecklistBus = new CustomerInvoiceChecklistBus(data[i]);
                    arr.push(newObj);
                }
            }

            this.checkList = arr;
        });
    }
    get hasUsers(): boolean {
        return CommonFunctions.hasValue(this.customerUsers);
    }
    customerUsers: GItem[];
    getCustomerUsers(id: any) {
        CommonFunctions.unsubscribe(this.subs_customerUsers);
        this.subs_customerUsers = this.svc_data.getCustomerUsersForCBO(id).subscribe(data => {
            this.customerUsers = data;
        });
    }

    get hasForms(): boolean {
        return CommonFunctions.hasValue(this.customerUsers);
    }
    customerCustomForms: CustomerCustomerForms[];
    getCustomerCustomForms(id: any) {
        CommonFunctions.unsubscribe(this.subs_customerCustomForms);
        this.subs_customerCustomForms = this.svc_data.GetCustomerCustomForms(id).subscribe(data => {
            this.customerCustomForms = data;
        });
    }

    invoiceCheckListAttachments: v_InvoiceCheckListAttachmentBus[];
    getinvoiceCheckListAttachments(id: any) {
        //CommonFunctions.unsubscribe(this.subs_customerCustomForms);
        this.subs_customerCustomForms = this.svc_data.GetCustomerCustomForms(id).subscribe(data => {

            this.svc_data.getInvoiceCheckListAttachments(id).subscribe(data => {
                let arr = [];
                if (data && CommonFunctions.hasArrayValue(data.primaryReturn)) {
                    for (let i = 0; i < data.primaryReturn.length; i++) {
                        let newObj: v_InvoiceCheckListAttachmentBus = new v_InvoiceCheckListAttachmentBus(data.primaryReturn[i]);
                        arr.push(newObj);
                    }
                }
                this.invoiceCheckListAttachments = arr;
            });
        });
    }

    invoiceCheckListNotes: v_InvoiceCheckListNoteBus[];
    getinvoiceCheckListNotes(id: any) {
        this.svc_data.getInvoiceCheckListNotes(id).subscribe(data => {
            let arr = [];
            if (data && CommonFunctions.hasArrayValue(data.primaryReturn)) {
                for (let i = 0; i < data.primaryReturn.length; i++) {
                    let newObj: v_InvoiceCheckListNoteBus = new v_InvoiceCheckListNoteBus(data.primaryReturn[i]);
                    arr.push(newObj);
                }
            }
            this.invoiceCheckListNotes = arr;
        });
    }

    get hasPms(): boolean {
        return CommonFunctions.hasValue(this.customerPMs);
    }
    customerPMs: CustomerPmsBus[];
    getCustomerPMs(id: any) {
        CommonFunctions.unsubscribe(this.subs_customerPM);
        this.subs_customerPM = this.svc_data.GetCustomerPms(id).subscribe(data => {
            let arr = [];
            if (CommonFunctions.hasArrayValue(data)) {
                for (let i = 0; i < data.length; i++) {
                    let newObj: CustomerPmsBus = new CustomerPmsBus(data[i]);
                    arr.push(newObj);
                }
            }
            this.customerPMs = arr;
        });
    }
    get hasQuestons(): boolean {
        return CommonFunctions.hasValue(this.customerPMs);
    }
    customerQuestions: CustomerOnbDataBus[];
    getCustomerQuestions(id: any) {
        CommonFunctions.unsubscribe(this.subs_onbData);
        this.subs_onbData = this.svc_data.GetCustomerQuestions(id).subscribe(data => {
            let arr = [];
            if (CommonFunctions.hasArrayValue(data)) {
                for (let i = 0; i < data.length; i++) {
                    let newObj: CustomerOnbDataBus = new CustomerOnbDataBus(data[i]);
                    arr.push(newObj);
                }
            }

            this.customerQuestions = arr;
        });
    }
    locationCBOs: GItem[];
    locationActiveCBOs: GItem[];
    getCustomerLocations(id: any) {
        CommonFunctions.unsubscribe(this.subs_location);
        this.subs_location = this.svc_data.getCustomerLocationsForCBO(id).subscribe(data => {
            this.locationCBOs = data;
            this.locationActiveCBOs = this.locationCBOs.filter(a => a.canSelect);
        });

    }
    get hasCustomerDispatchStatisticsDetails(): boolean {
        return CommonFunctions.hasValue(this.customerDispatchStatisticsDetails) && this.customerDispatchStatisticsDetails.length > 0;
    }
    getCustomerDispatchStatisticsDetails(id: any) {
        CommonFunctions.unsubscribe(this.subs_dispatchStats);
        this.subs_dispatchStats = this.svc_data.getCustomerDispatchStatisticDetails(id).subscribe(data => {
            (data && data.length > 0);
            {
                let arr = [];
                if (CommonFunctions.hasArrayValue(data)) {
                    for (let i = 0; i < data.length; i++) {
                        let newObj: CustomerDispatchStatisticsDetail = new CustomerDispatchStatisticsDetail(data[i]);
                        arr.push(newObj);
                    }
                }

                this.customerDispatchStatisticsDetails = arr;
            }
        });
    }
    customerDispatchStatisticsDetails: CustomerDispatchStatisticsDetail[];
    getCustomerDispatchStatistics(id: any) {
        CommonFunctions.unsubscribe(this.subs_dispatchStats);
        this.subs_dispatchStats = this.svc_data.getCustomerDispatchStatistics(id).subscribe(data => {
            (data && data.length > 0);
            {
                if (data[0]) {
                    this.customerDispatchStatistics = data[0];
                    this.customerDispatchStatistics.loading = false;
                }
                else {
                    this.customerDispatchStatistics = new CustomerDispatchStatistics(null);
                    this.customerDispatchStatistics.loading = false;

                }

            }
        });

    }
    customerDispatchStatistics: CustomerDispatchStatistics;

    clearAll() {

        this.locationCBOs = null;
        this.locationActiveCBOs = null;
        this.customerQuestions = null;
        this.customerPMs = null;
        this.customerCustomForms = null;
        this.customerUsers = null;
        this.checkList = null;
        this.customerInventory = null;
        this.customerProcedures = null;
        this.billingCodeRates = null;
        this.customerPricing = null;
        this.customerContact = null;
        this.statusHistory = null;
        this.customerDispatchStatisticsDetails = null;
        this.customerInvoiceBillingCodes = null;
        this.customerInvoiceBillingCodeMarkups = null;
        this.customerDispatchStatistics = {} as CustomerDispatchStatistics;
        this.invoiceCheckListAttachments = null;

    }

    setNew() {

        this.locationCBOs = [];
        this.locationActiveCBOs = [];
        this.customerQuestions = [];
        this.customerPMs = [];
        this.customerCustomForms = [];
        this.customerUsers = [];
        this.checkList = [];
        this.customerInventory = [];
        this.customerInventoryHistory = [];
        this.customerProcedures = [];
        this.billingCodeRates = [];
        this.customerPricing = [];
        this.customerPricingHistory = [];
        this.customerContact = [];
        this.statusHistory = [];
        this.customerInvoiceBillingCodes = [];
        this.customerInvoiceBillingCodeMarkups = [];
        this.customerDispatchStatisticsDetails = null;
        this.customerDispatchStatistics = {} as CustomerDispatchStatistics;
        this.invoiceCheckListAttachments = [];

    }
}
